/** * @author FightFastest * @date 28/12/2021 下午 3:35 */
<script>
export default {
	name: 'tables',
	data() {
		return {
			tableList: []
		}
	},
	props: {
		info: {
			type: Array,
			default: () => []
		},
		subName: {
			type: String,
			default: ''
		}
	},
	mounted() {
		let tableList = [],
			clsList = []
		this.info.forEach(res => {
			let row = {}
			res.sqaList.forEach(resp => {
				if (!row[resp.className]) row[resp.className] = {}
				row[resp.className]['className'] = resp.className
				row[resp.className][`${res.examId}avgScore`] = resp.avgScore
				row[resp.className][`${res.examId}avgScoreRank`] = resp.avgScoreRank
				row[resp.className][`${res.examId}superAvg`] = resp.superAvg
			})
			clsList.push(row)
		})
		clsList.forEach(res => {
			for (let cls in res) {
				if (!tableList[cls]) tableList[cls] = {}
				tableList[cls] = Object.assign({}, tableList[cls], res[cls])
			}
		})
		this.tableList = Object.values(tableList)
	},
	render(createElement) {
		return createElement(
			'div',
			{
				class: {
					foo: true
				}
			},
			[
				createElement(
					'el-table',
					{
						props: {
							data: this.tableList
						}
					},
					[
						createElement('el-table-column', {
							props: {
								prop: 'className',
								label: '班级',
								align: 'center'
							}
						}),
						createElement(
							'el-table-column',
							{
								props: {
									prop: 'className',
									label: `${this.subName}平均分`,
									align: 'center'
								}
							},
							[...this.creList(createElement, 'avgScore')]
						),
						createElement(
							'el-table-column',
							{
								props: {
									prop: 'className',
									label: `${this.subName}超均率`,
									align: 'center'
								}
							},
							[...this.creList(createElement, 'superAvg')]
						),
						createElement(
							'el-table-column',
							{
								props: {
									prop: 'className',
									label: `${this.subName}排名`,
									align: 'center'
								}
							},
							[...this.creList(createElement, 'avgScoreRank')]
						)
					]
				)
			]
		)
	},
	methods: {
		creList(createElement, flag) {
			let resArr = []
			this.info.forEach(res => {
				resArr.push(
					createElement('el-table-column', {
						props: {
							prop: `${res.examId}${flag}`,
							label: `${res.beginTime}`,
							align: 'center'
						}
					})
				)
			})
			return resArr
		}
	}
}
</script>

<style scoped lang="less">
.tables {
	width: 100%;
	background: red;
}
</style>
